"use strict";

$("#searchField").keyup(function (event) {
    // if (window.phonefilter) {
    //     clearTimeout(window.phonefilter);
    // }
    // window.phonefilter = setTimeout(filterData($(event.target).val()), 500);
    filterData($(event.target).val());
});

function filterData(searchValue) {
    var regexp = ".*" + searchValue + ".*";

    var fields = jQuery("#dealershipList").find(".modal-body .mb-4");

    for (i = 0; i < fields.length; i++) {
        if ($(fields[i]).text().trim().toLowerCase().match(regexp.toLowerCase())) {
            $(fields[i]).removeClass('d-none');
            $(fields[i]).addClass('d-block');
        } else {
            $(fields[i]).removeClass('d-block');
            $(fields[i]).addClass('d-none');
        }
    }
}